import {
  FilterRoute,
  getAppliedFilters,
  useAppSelector,
} from '@zonofi/zono-money-store';
import React from 'react';
import { ReactComponent as FilterIcon } from '@zonofi/svg-icons/filter-icon.svg';
import { hasAppliedFilters } from './helpers';
import './filter-button.scss';

export interface FilterButtonProps {
  route: FilterRoute;
  color?: string;
}

export interface FilterButtonWrapperProps extends FilterButtonProps {
  onClick?: () => void;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  route,
  color = '#ffffff',
}) => {
  const appliedFilters = useAppSelector(getAppliedFilters(route));
  const hasApplied = hasAppliedFilters(appliedFilters);
  return (
    <div className="filter-button">
      <FilterIcon color={color} />
      {hasApplied && <div className="red-dot" />}
    </div>
  );
};

export const WrapperdFilterButton: React.FC<FilterButtonWrapperProps> = ({
  route,
  color = '#ffffff',
  onClick = () => {},
}) => {
  const appliedFilters = useAppSelector(getAppliedFilters(route));
  const hasApplied = hasAppliedFilters(appliedFilters);
  return (
    <div className="filter-icon" onClick={onClick}>
      <FilterIcon color={color} />
      {hasApplied && <div className="red-dot" />}
    </div>
  );
};
